var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendingUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_272_4485)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3898 11.0272C50.2034 11.8408 50.2034 13.1599 49.3898 13.9735L29.5981 33.7651C28.7845 34.5787 27.4655 34.5787 26.6519 33.7651L17.7083 24.8216L3.55647 38.9735C2.74288 39.7871 1.42379 39.7871 0.610194 38.9735C-0.203398 38.1599 -0.203398 36.8408 0.610194 36.0272L16.2352 20.4022C17.0488 19.5886 18.3679 19.5886 19.1815 20.4022L28.125 29.3457L46.4435 11.0272C47.2571 10.2136 48.5762 10.2136 49.3898 11.0272Z",
    fill: "#F7BC52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3333 12.5003C33.3333 11.3497 34.2661 10.417 35.4166 10.417H47.9166C49.0672 10.417 50 11.3497 50 12.5003V25.0003C50 26.1509 49.0672 27.0837 47.9166 27.0837C46.7661 27.0837 45.8333 26.1509 45.8333 25.0003V14.5837H35.4166C34.2661 14.5837 33.3333 13.6509 33.3333 12.5003Z",
    fill: "#F7BC52"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_272_4485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendingUp);
export default __webpack_public_path__ + "static/media/trending-up.6412d2589e8d30c3e54f47ca5156205f.svg";
export { ForwardRef as ReactComponent };